import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SeguimientoAnonimoGatewayHttpService,
  SeguimientoAnonimoGatewayPostOptions,
} from '../interceptor/seguimiento-anonimo-http';

export interface SeguimientoAnonimoViajeRequest {
  key: string;
  tkt_h: string;
  id1: string;
}

export interface SeguimientoAnonimoViajeDatosRow {
  ROL?: string;
  VIAJESH?: unknown[];
  [key: string]: unknown;
}

export interface SeguimientoAnonimoViajeResponse {
  success: boolean;
  token?: string;
  datos?: SeguimientoAnonimoViajeDatosRow[];
  code?: string;
  message?: string;
  errors?: unknown;
}

export function extractRolFromSeguimientoAnonimoViajes(
  raw: SeguimientoAnonimoViajeResponse
): string | null {
  const rol = raw.datos?.[0]?.ROL;
  return rol != null ? String(rol) : null;
}

/** POST /api/seguimiento-anonimo/viajes — apertura pública del flujo (sin Bearer). */
@Injectable({ providedIn: 'root' })
export class SeguimientoAnonimoViajesGatewayApi {
  constructor(private readonly gw: SeguimientoAnonimoGatewayHttpService) {}

  post(
    body: SeguimientoAnonimoViajeRequest,
    options?: SeguimientoAnonimoGatewayPostOptions
  ): Observable<SeguimientoAnonimoViajeResponse> {
    return this.gw.post<SeguimientoAnonimoViajeResponse>('/viajes', body, options);
  }
}
